import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function ModalRegistrationHistory({
  handleClose,
  registerEventHistory,
}) {
  const { t } = useTranslation();

  function transactionStatus(status) {
    if (status === 0) {
      return (
        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-700 border border-yellow-200">
          <span className="w-2 h-2 rounded-full mr-2 bg-yellow-500"></span>{' '}
          Pending
        </span>

      )
    } else if (status === 1) {
      return (
        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-700 border border-green-200">
          <span className="w-2 h-2 rounded-full mr-2 bg-green-500"></span>{' '}
          Paid
        </span>
      )
    } else if (status === -1) {
      return (
        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-700 border border-red-200">
          <span className="w-2 h-2 rounded-full mr-2 bg-red-500"></span>{' '}
          Expired
        </span>
      )
    } else {
      return <></>
    }
  }

  useEffect(() => {
    const originalOverflow = document.body.style.overflow;

    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 overflow-hidden">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity flex items-center justify-center">
        <div className="relative m-4 bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[50vh] overflow-hidden transform transition-all">
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-[#F79838]">
            <h2 className="text-xl font-bold text-white font-poppins flex items-center gap-3">
              <svg
                className="w-6 h-6]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
              </svg>
              {t('profile.registerHistoryModal')}
            </h2>
            <button
              onClick={() => handleClose(false)}
              className="p-2 rounded-full text-white/80 hover:text-white hover:bg-white/10 transition-colors"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
          <div className="p-6 overflow-y-auto max-h-[calc(50vh-80px)]">
            {registerEventHistory.length > 0 ? (
              <div className="overflow-hidden rounded-xl border border-gray-200 shadow-sm font-poppins">
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead className="bg-gray-100 text-black">
                      <tr>
                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider">
                          Registration Code
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider">
                          Status
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider">
                          Registration Date
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                      {registerEventHistory.map((data) => (
                        <tr
                          key={data.uuehId}
                          className="hover:bg-gray-50 transition-colors"
                        >
                          <td className="px-4 py-4">
                            <div className="flex items-center gap-2">
                              <div className="w-8 h-8 rounded-lg bg-brand-blue/10 flex items-center justify-center">
                                <svg
                                  className="w-4 h-4 text-brand-blue"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"
                                  ></path>
                                </svg>
                              </div>
                              <a
                                className="font-mono font-medium text-black"
                                // href={`/registration/form?invoice=true&amp;invoiceId=${data.uuehRefId}`}
                                href={`/registration#!/invoice/${data.uuehRefId}`}
                              >
                                {data.uuehRefId}
                              </a>
                            </div>
                          </td>
                          <td className="px-4 py-4">
                            {transactionStatus(data?.uuehTrnsStatus)}
                          </td>
                          <td className="px-4 py-4">
                            <div className="flex items-center gap-2 text-gray-600">
                              <svg
                                className="w-4 h-4 text-gray-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                ></path>
                              </svg>
                              <span className="text-sm">
                                {new Date(
                                  data.uuehCreatedTime,
                                ).toLocaleDateString('id-ID', {
                                  year: 'numeric',
                                  month: 'long',
                                  day: '2-digit',
                                  hour: 'numeric',
                                  minute: '2-digit',
                                })}
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="px-4 py-3 bg-gray-50 border-t border-gray-200 flex items-center justify-between text-sm">
                  <span className="text-gray-600">
                    Total Events:{' '}
                    <span className="font-semibold text-brand-blue">
                      {registerEventHistory.length}
                    </span>
                  </span>
                  <div className="flex items-center gap-4">
                    <span className="flex items-center gap-1">
                      <span className="w-2 h-2 rounded-full bg-green-500"></span>
                      <span className="text-gray-600">
                        Paid:{' '}
                        <span className="font-semibold text-brand-blue">
                          {registerEventHistory
                            .map((data) => data.uuehTrnsStatus === 1)
                            .reduce((acc, curr) => acc + curr, 0)}
                        </span>
                      </span>
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="w-2 h-2 rounded-full bg-yellow-500"></span>
                      <span className="text-gray-600">
                        Pending:{' '}
                        <span className="font-semibold text-brand-blue">
                          {registerEventHistory
                            .map((data) => data.uuehTrnsStatus === 0)
                            .reduce((acc, curr) => acc + curr, 0)}
                        </span>
                      </span>
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="w-2 h-2 rounded-full bg-red-500"></span>
                      <span className="text-gray-600">
                        Expired:{' '}
                        <span className="font-semibold text-brand-blue">
                          {registerEventHistory
                            .map((data) => data.uuehTrnsStatus === -1)
                            .reduce((acc, curr) => acc + curr, 0)}
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                {/* {registerEventHistory.map((data) => (
                    <div className="flex items-center justify-between bg-white rounded-xl p-5  border border-gray-100 shadow-sm hover:shadow-lg hover:border-[#164481]/20 transition-all duration-300 ease-out transform hover:-translate-y-1 mb-6">
                      <div className="flex flex-col items-start">
                        <h1 className="text-xs">{data.uuehRefId}</h1>
                        <h4 className="text-gray-500 max-w-sm text-xs">
                          {data.uuehRefId}
                        </h4>
                      </div>
                      <p className="text-[12px]">
                        {data.uuehTrnsStatusLabel?.toUpperCase()}
                      </p>
                    </div>
                  ))} */}
              </div>
            ) : (
              <div className="text-center py-12">
                <div className="w-20 h-20 bg-[#164481]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg
                    className="w-10 h-10 text-black"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                    ></path>
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-black mb-2">
                  {t('profile.titleModal')}
                </h3>
                <p className="text-gray-500 max-w-sm mx-auto">
                  {t('profile.descriptionModal')}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
